import { useState } from 'react';
import { useNavigate, useParams } from '@tanstack/react-router';
import { useAuthStore } from '../store/auth.ts';

export function AcceptInvite(): JSX.Element {
  const navigate = useNavigate();
  const { token } = useParams({ from: '/invite/$token' });
  const reg = useAuthStore((s) => s.registerViaInvite);
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm card-paper p-6 sm:p-8 space-y-6">
        <h1 className="font-sans text-3xl">Accept your invite</h1>
        <form
          className="space-y-4"
          onSubmit={async (e) => {
            e.preventDefault();
            setError(null);
            try {
              await reg(token, password, name);
              await navigate({ to: '/dashboard' });
            } catch {
              setError('Invite is invalid or expired.');
            }
          }}
        >
          <div className="space-y-1.5">
            <label htmlFor="ai-name" className="field-label">Your name</label>
            <input
              id="ai-name"
              className="input"
              placeholder="Your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="space-y-1.5">
            <label htmlFor="ai-password" className="field-label">Password</label>
            <input
              id="ai-password"
              className="input"
              type="password"
              placeholder="Choose a password (≥ 8 chars)"
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
          <button type="submit" className="btn-primary w-full">
            Create account
          </button>
        </form>
      </div>
    </div>
  );
}
